export enum RequestStatus {
  DRAFT = "draft",
  OPEN = "open",
  PENDING = "pending",
  CLOSED = "closed",
}

export enum RequestPriority {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  URGENT = "urgent",
}

export enum WorkingModel {
  ONSITE = "onsite",
  REMOTE = "remote",
  FREELANCER = "freelancer",
  HYBRID = "hybrid",
}

export enum Gender {
  ANY = "any",
  MALE = "male",
  FEMALE = "female",
}

export enum TechStackLevel {
  JUNIOR = "junior",
  MID = "mid",
  SENIOR = "senior",
  LEAD = "lead",
}

export enum LanguageProficiency {
  BASIC = "basic",
  INTERMEDIATE = "intermediate",
  ADVANCED = "advanced",
  FLUENT = "fluent",
  NATIVE = "native",
}

export enum SalaryRange {
  UNDER_1000 = "under_1000",
  FROM_1000_TO_1500 = "from_1000_to_1500",
  FROM_1500_TO_2000 = "from_1500_to_2000",
  ABOVE_2000 = "above_2000",
}

export enum FailureReason {
  SALES_FAIL = "sales_fail",
  NO_SUITABLE_CANDIDATES = "no_suitable_candidates",
  NO_TECH_IN_MARKET = "no_tech_in_market",
  WEAK_TA = "weak_ta",
  OTHER = "other",
}

